import { takeLatest, put, call } from "redux-saga/effects";
import reportCampaignAction from "../actions/reportCampaignAction";
import HttpService from "../../services/httpServices/httpServices";
import helperSpinner from "../../helpers/spinner";

const getHeaderForRequest = () => {
  const token = localStorage.getItem("token");
  const headersRequest = {
    headers: {
      authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    },
  };

  return headersRequest;
};

const getCampaignReportBrowserCitiesWorker = function* (action) {
  const campaignID = action.payload.campaign_id;
  const date_from = action.payload.date_from.replace(" ", "_");
  const date_to = action.payload.date_to.replace(" ", "_");
  // helperSpinner.showSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);
  try {
    const result = yield call(() => {
      const url =
        process.env.REACT_APP_DOMAIN_API +
        "/v1/report/browser-cities/campaign/" +
        campaignID +
        "?date_from=" +
        date_from +
        "&date_to=" +
        date_to;
      const headersRequest = getHeaderForRequest();
      return HttpService.getRequest(url, headersRequest);
    });
    let payloadDate = {
      data: result.data.data,
      campaignID: campaignID,
    };
    yield put({
      type: reportCampaignAction.GET_CAMPAIGN_REPORT_BROWSER_CITIES_SUCCESS,
      payload: payloadDate,
    });
  } catch (error) {
    yield put({
      type: reportCampaignAction.GET_CAMPAIGN_REPORT_BROWSER_CITIES_FAILED,
      payload: null,
    });
  }
  // helperSpinner.removeSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);
};

const getCampaignReportWithCampaignNameWorker = function* (action) {
  const campaignID = action.payload.campaign_id;
  const date_from = action.payload.date_from.replace(" ", "_");
  const date_to = action.payload.date_to.replace(" ", "_");
  helperSpinner.showSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);
  try {
    const result = yield call(() => {
      const url =
        process.env.REACT_APP_DOMAIN_API +
        "/v1/report/campaign/" +
        campaignID +
        "?date_from=" +
        date_from +
        "&date_to=" +
        date_to;
      const headersRequest = getHeaderForRequest();
      return HttpService.getRequest(url, headersRequest);
    });
    let payloadDate = {
      ...result.data.data,
      campaignID: campaignID,
    };
    yield put({
      type: reportCampaignAction.GET_REPORT_CAMPAIGN_SUCCESS,
      payload: payloadDate,
    });
  } catch (error) {
    yield put({
      type: reportCampaignAction.GET_REPORT_CAMPAIGN_FAILED,
      payload: null,
    });
  }
  helperSpinner.removeSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);
};

const getCampaignReportBrowserWithCampaignNameWorker = function* (action) {
  const campaignID = action.payload.campaign_id;
  const date_from = action.payload.date_from.replace(" ", "_");
  const date_to = action.payload.date_to.replace(" ", "_");
  try {
    const result = yield call(() => {
      const url =
        process.env.REACT_APP_DOMAIN_API +
        "/v1/report/browser-data/campaign/" +
        campaignID +
        "?date_from=" +
        date_from +
        "&date_to=" +
        date_to;
      const headersRequest = getHeaderForRequest();
      return HttpService.getRequest(url, headersRequest);
    });

    let payloadDate = {
      ...result.data.data,
      campaignID: campaignID,
    };

    yield put({
      type: reportCampaignAction.GET_CAMPAIGN_REPORT_BROWSER_SUCCESS,
      payload: payloadDate,
    });
  } catch (error) {
    yield put({
      type: reportCampaignAction.GET_CAMPAIGN_REPORT_BROWSER_FAILED,
      payload: null,
    });
  }
};

const getCampaignsReportWithTypeCampaignWorker = function* (action) {
  const campaignType = action.payload.campaign_type;
  const date_from = action.payload.date_from.replace(" ", "_");
  const date_to = action.payload.date_to.replace(" ", "_");
  helperSpinner.showSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);
  try {
    const result = yield call(() => {
      const url =
        process.env.REACT_APP_DOMAIN_API +
        "/v1/report/campaigns?type=" +
        campaignType +
        "&date_from=" +
        date_from +
        "&date_to=" +
        date_to;
      const headersRequest = getHeaderForRequest();
      return HttpService.getRequest(url, headersRequest);
    });

    let payloadDate = {
      ...result.data.data,
      campaign_type: campaignType,
    };
    yield put({
      type: reportCampaignAction.GET_CAMPAIGNS_REPORT_SUCCESS,
      payload: payloadDate,
    });
  } catch (error) {
    yield put({
      type: reportCampaignAction.GET_CAMPAIGNS_REPORT_FAILED,
      payload: error.response.data.message,
    });
  }
  helperSpinner.removeSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);
};

const getCampaignsDataChartWithCampaignNameWorker = function* (action) {
  const campaignID = action.payload.campaign_id;
  const eventDataChart = action.payload.event_data_chart;
  let dateFrom = action.payload.date_from.replace(" ", "_");
  let dateTo = action.payload.date_to.replace(" ", "_");
  helperSpinner.showSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);

  try {
    const result = yield call(() => {
      const url =
        process.env.REACT_APP_DOMAIN_API +
        `/v1/report/data-chart/campaign/${campaignID}` +
        "?event=" +
        eventDataChart +
        "&date_from=" +
        dateFrom +
        "&date_to=" +
        dateTo;
      const headersRequest = getHeaderForRequest();
      return HttpService.getRequest(url, headersRequest);
    });

    dateFrom = action.payload.date_from.replace("_", " ");
    dateTo = action.payload.date_to.replace("_", " ");
    let payloadDate = {
      date_from: dateFrom,
      date_to: dateTo,
      data_chart: result.data.data,
    };
    yield put({
      type: reportCampaignAction.GET_DATA_CHART_SUCCESS,
      payload: payloadDate,
    });
  } catch (error) {
    yield put({
      type: reportCampaignAction.GET_DATA_CHART_FAILED,
      payload: null,
    });
  }
  helperSpinner.removeSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);
};

const getCampaignsDataChartWithCampaignTypeWorker = function* (action) {
  const campaignType = action.payload.campaign_type;
  const eventDataChart = action.payload.event_data_chart;
  let dateFrom = action.payload.date_from.replace(" ", "_");
  let dateTo = action.payload.date_to.replace(" ", "_");
  helperSpinner.showSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);
  try {
    const result = yield call(() => {
      const url =
        process.env.REACT_APP_DOMAIN_API +
        `/v1/report/data-chart/campaigns?type=` +
        campaignType +
        "&event=" +
        eventDataChart +
        "&date_from=" +
        dateFrom +
        "&date_to=" +
        dateTo;
      const headersRequest = getHeaderForRequest();
      return HttpService.getRequest(url, headersRequest);
    });

    dateFrom = action.payload.date_from.replace("_", " ");
    dateTo = action.payload.date_to.replace("_", " ");
    let payloadData = {
      date_from: dateFrom,
      date_to: dateTo,
      data_chart: result.data.data,
    };
    yield put({
      type: reportCampaignAction.GET_DATA_CHART_SUCCESS,
      payload: payloadData,
    });
  } catch (error) {
    yield put({
      type: reportCampaignAction.GET_DATA_CHART_FAILED,
      payload: null,
    });
  }
  helperSpinner.removeSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);
};

const getCampaignsDataSeparationWithCampaignNameWorker = function* (action) {
  const campaignID = action.payload.campaign_id;
  const separation = action.payload.separation.toLowerCase();
  let dateFrom = action.payload.date_from.replace(" ", "_");
  let dateTo = action.payload.date_to.replace(" ", "_");
  helperSpinner.showSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);
  try {
    const result = yield call(() => {
      const url =
        process.env.REACT_APP_DOMAIN_API +
        `/v1/report/data-separation/campaign/` +
        campaignID +
        "?separation=" +
        separation +
        "&date_from=" +
        dateFrom +
        "&date_to=" +
        dateTo;
      const headersRequest = getHeaderForRequest();
      return HttpService.getRequest(url, headersRequest);
    });

    dateFrom = action.payload.date_from.replace("_", " ");
    dateTo = action.payload.date_to.replace("_", " ");
    let payloadData = {
      date_from: dateFrom,
      date_to: dateTo,
      data_chart_separation: result.data.data,
    };
    yield put({
      type: reportCampaignAction.GET_CAMPAIGNS_DATA_SEPARATION_SUCCESS,
      payload: payloadData,
    });
  } catch (error) {
    yield put({
      type: reportCampaignAction.GET_CAMPAIGNS_DATA_SEPARATION_FAILED,
      payload: null,
    });
  }
  helperSpinner.removeSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);
};

const getCampaignsDataSeparationWithCampaignTypeWorker = function* (action) {
  const campaignType = action.payload.campaign_type;
  const separation = action.payload.separation.toLowerCase();
  let dateFrom = action.payload.date_from.replace(" ", "_");
  let dateTo = action.payload.date_to.replace(" ", "_");
  helperSpinner.showSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);
  try {
    const result = yield call(() => {
      const url =
        process.env.REACT_APP_DOMAIN_API +
        `/v1/report/data-separation/campaigns?type=` +
        campaignType +
        "&separation=" +
        separation +
        "&date_from=" +
        dateFrom +
        "&date_to=" +
        dateTo;
      const headersRequest = getHeaderForRequest();
      return HttpService.getRequest(url, headersRequest);
    });

    dateFrom = action.payload.date_from.replace("_", " ");
    dateTo = action.payload.date_to.replace("_", " ");
    let payloadData = {
      date_from: dateFrom,
      date_to: dateTo,
      data_chart_separation: result.data.data,
    };
    yield put({
      type: reportCampaignAction.GET_CAMPAIGNS_DATA_SEPARATION_SUCCESS,
      payload: payloadData,
    });
  } catch (error) {
    yield put({
      type: reportCampaignAction.GET_CAMPAIGNS_DATA_SEPARATION_FAILED,
      payload: null,
    });
  }
  helperSpinner.removeSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);
};

const getCampaignsBrowserDataWithCampaignTypeWorker = function* (action) {
  const campaignType = action.payload.campaign_type;
  let dateFrom = action.payload.date_from.replace(" ", "_");
  let dateTo = action.payload.date_to.replace(" ", "_");
  try {
    const result = yield call(() => {
      const url =
        process.env.REACT_APP_DOMAIN_API +
        `/v1/report/browser-data/campaigns?type=` +
        campaignType +
        "&date_from=" +
        dateFrom +
        "&date_to=" +
        dateTo;
      const headersRequest = getHeaderForRequest();
      return HttpService.getRequest(url, headersRequest);
    });

    dateFrom = action.payload.date_from.replace("_", " ");
    dateTo = action.payload.date_to.replace("_", " ");
    let payloadDate = {
      ...result.data.data,
    };
    yield put({
      type: reportCampaignAction.GET_CAMPAIGNS_REPORT_BROWSER_SUCCESS,
      payload: payloadDate,
    });
  } catch (error) {
    yield put({
      type: reportCampaignAction.GET_CAMPAIGNS_REPORT_BROWSER_FAILED,
      payload: null,
    });
  }
};

const getCampaignsReportBrowserCitiesWorker = function* (action) {
  const date_from = action.payload.date_from.replace(" ", "_");
  const date_to = action.payload.date_to.replace(" ", "_");
  // helperSpinner.showSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);
  try {
    const result = yield call(() => {
      const url =
        process.env.REACT_APP_DOMAIN_API +
        "/v1/report/browser-cities/campaigns?date_from=" +
        date_from +
        "&date_to=" +
        date_to;
      const headersRequest = getHeaderForRequest();
      return HttpService.getRequest(url, headersRequest);
    });
 
    let payloadDate = {
      data: result.data.data,
    };
    yield put({
      type: reportCampaignAction.GET_CAMPAIGNS_REPORT_BROWSER_CITIES_SUCCESS,
      payload: payloadDate,
    });
  } catch (error) {
    yield put({
      type: reportCampaignAction.GET_CAMPAIGNS_REPORT_BROWSER_CITIES_FAILED,
      payload: null,
    });
  }
  // helperSpinner.removeSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);
};

const getCampaignsReportBrowserIPWorker = function* (action) {
  const date_from = action.payload.date_from.replace(" ", "_");
  const date_to = action.payload.date_to.replace(" ", "_");
  helperSpinner.showSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);
  try {
    const result = yield call(() => {
      const url =
        process.env.REACT_APP_DOMAIN_API +
        "/v1/report/browser-ip/campaigns?date_from=" +
        date_from +
        "&date_to=" +
        date_to;
      const headersRequest = getHeaderForRequest();
      return HttpService.getRequest(url, headersRequest);
    });

    let payloadDate = {
      data: result.data.data,
    };
    yield put({
      type: reportCampaignAction.GET_CAMPAIGNS_REPORT_BROWSER_IP_SUCCESS,
      payload: payloadDate,
    });
  } catch (error) {
    yield put({
      type: reportCampaignAction.GET_CAMPAIGNS_REPORT_BROWSER_IP_FAILED,
      payload: null,
    });
  }
  helperSpinner.removeSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);
};

const getCampaignReportBrowserIPWorker = function* (action) {
  const date_from = action.payload.date_from.replace(" ", "_");
  const date_to = action.payload.date_to.replace(" ", "_");
  const campaignID = action.payload.campaign_id;
  helperSpinner.showSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);
  try {
    const result = yield call(() => {
      const url =
        process.env.REACT_APP_DOMAIN_API +
        "/v1/report/browser-ip/campaign/" +
        campaignID +
        "?date_from=" +
        date_from +
        "&date_to=" +
        date_to;
      const headersRequest = getHeaderForRequest();
      return HttpService.getRequest(url, headersRequest);
    });
    let payloadDate = {
      data: result.data.data,
    };
    yield put({
      type: reportCampaignAction.GET_CAMPAIGN_REPORT_BROWSER_IP_SUCCESS,
      payload: payloadDate,
    });
  } catch (error) {
    yield put({
      type: reportCampaignAction.GET_CAMPAIGN_REPORT_BROWSER_IP_FAILED,
      payload: null,
    });
  }
  helperSpinner.removeSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);
};

export const getCampaignReportWithCampaignNameWatcher = function* () {
  yield takeLatest(
    reportCampaignAction.GET_CAMPAIGN_REPORT_WITH_CAMPAIGN_NAME,
    getCampaignReportWithCampaignNameWorker
  );
  yield takeLatest(
    reportCampaignAction.GET_CAMPAIGNS_REPORT_WITH_CAMPAIGN_TYPE,
    getCampaignsReportWithTypeCampaignWorker
  );
  yield takeLatest(
    reportCampaignAction.GET_CAMPAIGNS_DATA_CHART_WITH_CAMPAIGN_NAME,
    getCampaignsDataChartWithCampaignNameWorker
  );
  yield takeLatest(
    reportCampaignAction.GET_CAMPAIGNS_DATA_CHART_WITH_CAMPAIGN_TYPE,
    getCampaignsDataChartWithCampaignTypeWorker
  );
  yield takeLatest(
    reportCampaignAction.GET_CAMPAIGNS_DATA_SEPARATION_WITH_CAMPAIGN_NAME,
    getCampaignsDataSeparationWithCampaignNameWorker
  );
  yield takeLatest(
    reportCampaignAction.GET_CAMPAIGNS_DATA_SEPARATION_WITH_CAMPAIGN_TYPE,
    getCampaignsDataSeparationWithCampaignTypeWorker
  );
  yield takeLatest(
    reportCampaignAction.GET_CAMPAIGN_REPORT_BROWSER,
    getCampaignReportBrowserWithCampaignNameWorker
  );
  yield takeLatest(
    reportCampaignAction.GET_CAMPAIGNS_REPORT_BROWSER,
    getCampaignsBrowserDataWithCampaignTypeWorker
  );
  yield takeLatest(
    reportCampaignAction.GET_CAMPAIGN_REPORT_BROWSER_CITIES,
    getCampaignReportBrowserCitiesWorker
  );
  yield takeLatest(
    reportCampaignAction.GET_CAMPAIGNS_REPORT_BROWSER_CITIES,
    getCampaignsReportBrowserCitiesWorker
  );
  yield takeLatest(
    reportCampaignAction.GET_CAMPAIGN_REPORT_BROWSER_IP,
    getCampaignReportBrowserIPWorker
  );
  yield takeLatest(
    reportCampaignAction.GET_CAMPAIGNS_REPORT_BROWSER_IP,
    getCampaignsReportBrowserIPWorker
  );
};
